import { addIcons } from 'ionicons';
import { add, addCircleOutline, albumsOutline, alert, alertCircleOutline, analyticsOutline, arrowBackOutline, arrowForwardOutline, arrowRedo, arrowRedoOutline, arrowUndoOutline, at, bagHandleOutline, body, book, brush, brushOutline, bulb, card, cardOutline, chatbox, chatbubble, chatbubbleEllipsesOutline, chatbubbleOutline, chatbubbles, chatbubblesOutline, checkbox, checkmark, checkmarkCircle, checkmarkCircleOutline, checkmarkDoneOutline, checkmarkOutline, chevronBackOutline, chevronForwardOutline, close, closeOutline, cloudUploadOutline, colorFilterOutline, colorPaletteOutline, colorWandOutline, compassOutline, constructOutline, contrast, contrastOutline, create, createOutline, cropOutline, documentLock, documentLockOutline, documentOutline, documentText, documentTextOutline, downloadOutline, ellipse, ellipseOutline, ellipsisHorizontal, ellipsisHorizontalOutline, eye, eyeOffOutline, eyeOutline, filmOutline, filter, flagOutline, gitBranchOutline, gitNetwork, gitNetworkOutline, globeOutline, home, homeOutline, hourglassOutline, image, imageOutline, images, imagesOutline, informationCircle, informationCircleOutline, keyOutline, keypadOutline, language, layers, layersOutline, link, location, locationOutline, lockClosed, lockClosedOutline, lockOpenOutline, logInOutline, logoApple, logoFacebook, logoGoogle, logoGooglePlaystore, logoInstagram, logoLinkedin, logoPinterest, logoTwitter, mail, mailOutline, megaphoneOutline, menuOutline, micOutline, moonOutline, move, musicalNotes, musicalNotesOutline, newspaper, newspaperOutline, notifications, notificationsOutline, open, optionsOutline, pause, people, peopleCircleOutline, peopleOutline, person, personAdd, personAddOutline, personCircle, personCircleOutline, personOutline, personRemoveOutline, planetOutline, play, playCircleOutline, playOutline, pricetagOutline, push, radio, radioOutline, recording, resize, ribbonOutline, rocketOutline, saveOutline, scale, search, searchOutline, sendOutline, settings, settingsOutline, shareSocialOutline, shieldCheckmark, shieldCheckmarkOutline, shieldOutline, sparkles, sparklesOutline, star, starOutline, storefront, storefrontOutline, text, textOutline, timeOutline, trashOutline, trendingUpOutline, videocam, videocamOutline, volumeHighOutline, warning } from 'ionicons/icons';

// Existing website icons, registered before the first page renders.
addIcons({
  'add': add,
  'add-circle-outline': addCircleOutline,
  'albums-outline': albumsOutline,
  'alert': alert,
  'alert-circle-outline': alertCircleOutline,
  'analytics-outline': analyticsOutline,
  'arrow-back-outline': arrowBackOutline,
  'arrow-forward-outline': arrowForwardOutline,
  'arrow-redo': arrowRedo,
  'arrow-redo-outline': arrowRedoOutline,
  'arrow-undo-outline': arrowUndoOutline,
  'at': at,
  'bag-handle-outline': bagHandleOutline,
  'body': body,
  'book': book,
  'brush': brush,
  'brush-outline': brushOutline,
  'bulb': bulb,
  'card': card,
  'card-outline': cardOutline,
  'chatbox': chatbox,
  'chatbubble': chatbubble,
  'chatbubble-ellipses-outline': chatbubbleEllipsesOutline,
  'chatbubble-outline': chatbubbleOutline,
  'chatbubbles': chatbubbles,
  'chatbubbles-outline': chatbubblesOutline,
  'checkbox': checkbox,
  'checkmark': checkmark,
  'checkmark-circle': checkmarkCircle,
  'checkmark-circle-outline': checkmarkCircleOutline,
  'checkmark-done-outline': checkmarkDoneOutline,
  'checkmark-outline': checkmarkOutline,
  'chevron-back-outline': chevronBackOutline,
  'chevron-forward-outline': chevronForwardOutline,
  'close': close,
  'close-outline': closeOutline,
  'cloud-upload-outline': cloudUploadOutline,
  'color-filter-outline': colorFilterOutline,
  'color-palette-outline': colorPaletteOutline,
  'color-wand-outline': colorWandOutline,
  'compass-outline': compassOutline,
  'construct-outline': constructOutline,
  'contrast': contrast,
  'contrast-outline': contrastOutline,
  'create': create,
  'create-outline': createOutline,
  'crop-outline': cropOutline,
  'document-lock': documentLock,
  'document-lock-outline': documentLockOutline,
  'document-outline': documentOutline,
  'document-text': documentText,
  'document-text-outline': documentTextOutline,
  'download-outline': downloadOutline,
  'ellipse': ellipse,
  'ellipse-outline': ellipseOutline,
  'ellipsis-horizontal': ellipsisHorizontal,
  'ellipsis-horizontal-outline': ellipsisHorizontalOutline,
  'eye': eye,
  'eye-off-outline': eyeOffOutline,
  'eye-outline': eyeOutline,
  'film-outline': filmOutline,
  'filter': filter,
  'flag-outline': flagOutline,
  'git-branch-outline': gitBranchOutline,
  'git-network': gitNetwork,
  'git-network-outline': gitNetworkOutline,
  'globe-outline': globeOutline,
  'home': home,
  'home-outline': homeOutline,
  'hourglass-outline': hourglassOutline,
  'image': image,
  'image-outline': imageOutline,
  'images': images,
  'images-outline': imagesOutline,
  'information-circle': informationCircle,
  'information-circle-outline': informationCircleOutline,
  'key-outline': keyOutline,
  'keypad-outline': keypadOutline,
  'language': language,
  'layers': layers,
  'layers-outline': layersOutline,
  'link': link,
  'location': location,
  'location-outline': locationOutline,
  'lock-closed': lockClosed,
  'lock-closed-outline': lockClosedOutline,
  'lock-open-outline': lockOpenOutline,
  'log-in-outline': logInOutline,
  'logo-apple': logoApple,
  'logo-facebook': logoFacebook,
  'logo-google': logoGoogle,
  'logo-google-playstore': logoGooglePlaystore,
  'logo-instagram': logoInstagram,
  'logo-linkedin': logoLinkedin,
  'logo-pinterest': logoPinterest,
  'logo-twitter': logoTwitter,
  'mail': mail,
  'mail-outline': mailOutline,
  'megaphone-outline': megaphoneOutline,
  'menu-outline': menuOutline,
  'mic-outline': micOutline,
  'moon-outline': moonOutline,
  'move': move,
  'musical-notes': musicalNotes,
  'musical-notes-outline': musicalNotesOutline,
  'newspaper': newspaper,
  'newspaper-outline': newspaperOutline,
  'notifications': notifications,
  'notifications-outline': notificationsOutline,
  'open': open,
  'options-outline': optionsOutline,
  'pause': pause,
  'people': people,
  'people-circle-outline': peopleCircleOutline,
  'people-outline': peopleOutline,
  'person': person,
  'person-add': personAdd,
  'person-add-outline': personAddOutline,
  'person-circle': personCircle,
  'person-circle-outline': personCircleOutline,
  'person-outline': personOutline,
  'person-remove-outline': personRemoveOutline,
  'planet-outline': planetOutline,
  'play': play,
  'play-circle-outline': playCircleOutline,
  'play-outline': playOutline,
  'pricetag-outline': pricetagOutline,
  'push': push,
  'radio': radio,
  'radio-outline': radioOutline,
  'recording': recording,
  'resize': resize,
  'ribbon-outline': ribbonOutline,
  'rocket-outline': rocketOutline,
  'save-outline': saveOutline,
  'scale': scale,
  'search': search,
  'search-outline': searchOutline,
  'send-outline': sendOutline,
  'settings': settings,
  'settings-outline': settingsOutline,
  'share-social-outline': shareSocialOutline,
  'shield-checkmark': shieldCheckmark,
  'shield-checkmark-outline': shieldCheckmarkOutline,
  'shield-outline': shieldOutline,
  'sparkles': sparkles,
  'sparkles-outline': sparklesOutline,
  'star': star,
  'star-outline': starOutline,
  'storefront': storefront,
  'storefront-outline': storefrontOutline,
  'text': text,
  'text-outline': textOutline,
  'time-outline': timeOutline,
  'trash-outline': trashOutline,
  'trending-up-outline': trendingUpOutline,
  'videocam': videocam,
  'videocam-outline': videocamOutline,
  'volume-high-outline': volumeHighOutline,
  'warning': warning
});
